<template>
    <module-card>
        <div v-if="rubberMishapIncorrect.length > 0">
            <p>Oop!</p>
            <p>We get it, this was tough, but trying to use a condom when you’re high or drunk is even tougher. It’s best to be sober when having sex.</p>
        </div>
        <div v-else>
            <p>Nice job!</p>
            <p>You made it through with a great score. Remember, though, the real world is much hard than this game so it’s best to not be high or drunk when using a condom.</p>
        </div>
    </module-card>
</template>

<script>
    import { get } from 'vuex-pathify';

    export default {
        computed: {
            rubberMishapIncorrect: get('rubberMishapIncorrect')
        }
    };
</script>
